function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#48DBB4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30 0C13.437 0 0 13.437 0 30C0 46.563 13.437 60 30 60C46.563 60 60 46.563 60 30C59.9748 13.437 46.5378 0 30 0ZM42.5546 23.2941H40.6891L34.9664 29.9748L40.6891 36.6555H42.5798V42.0252H30.4286V36.7059H32.3193L28.563 32.3193H27.0252V36.7059H29.1681V42.0252H17.395V36.6555H19.9412V30V23.2941H17.395V17.9244H20.2941V19.916H21.8571V17.9244H24.7059V19.916H26.2689V17.9244H29.1429V23.2185H27V27.605H28.5378L32.2941 23.2185H30.4034V17.9244H42.5546V23.2941Z",
  fill: "#0A0806"
});

const SvgKeepToken = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKeepToken, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/keep-token.e15ce05e.svg";
export { ForwardRef as ReactComponent };